// DO NOT EDIT -- generated from fs/services/tally/tally.proto

import * as metrics from '../../api/metrics';
import * as protobuf from '../../../google/protobuf';
import * as segment from '../../api/segment';
import * as vars from '../../api/vars';

export namespace Cron {

  export const ProcessDefinitionHealthEndpoint = "/grpc/tally.Cron/ProcessDefinitionHealth";
  export function ProcessDefinitionHealth(sender: (req: GetProcessDefinitionHealthRequest, endpoint: string) => Promise<{}>, req: GetProcessDefinitionHealthRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, ProcessDefinitionHealthEndpoint),
      endpoint: ProcessDefinitionHealthEndpoint
    };
  }
}

export namespace AccuracySmokeCron {

  export const ProcessAccuracySmokeTestEndpoint = "/grpc/tally.AccuracySmokeCron/ProcessAccuracySmokeTest";
  export function ProcessAccuracySmokeTest(sender: (req: GetProcessAccuracySmokeTestRequest, endpoint: string) => Promise<{}>, req: GetProcessAccuracySmokeTestRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, ProcessAccuracySmokeTestEndpoint),
      endpoint: ProcessAccuracySmokeTestEndpoint
    };
  }
}

/**
 * Tally service provides access to the Tally data store.
 * Note: This service is PUBLIC so do not add things here that should not be available to outside callers.
 */
export namespace Tally {

  export const GetElementCountsEndpoint = "/grpc/tally.Tally/GetElementCounts";
  /**
   * Returns windows of hourly counts for the specified object and time frame.
   * [StartTime, EndTime) are inclusive and exclusive, respectively
   * If there are gaps in windows, then that means that
   * a) no matching events were found in that window
   * b) data has not yet been collected yet (more likely for recent windows)
   */
  export function GetElementCounts(sender: (req: GetElementCountsRequest, endpoint: string) => Promise<GetCountsResponse>, req: GetElementCountsRequest): { promise: () => Promise<GetCountsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetElementCountsEndpoint),
      endpoint: GetElementCountsEndpoint
    };
  }

  export const GetAllElementCountsEndpoint = "/grpc/tally.Tally/GetAllElementCounts";
  export function GetAllElementCounts(sender: (req: GetAllElementCountsRequest, endpoint: string) => Promise<GetAllCountsResponse>, req: GetAllElementCountsRequest): { promise: () => Promise<GetAllCountsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllElementCountsEndpoint),
      endpoint: GetAllElementCountsEndpoint
    };
  }

  export const GetAlertCountsEndpoint = "/grpc/tally.Tally/GetAlertCounts";
  export function GetAlertCounts(sender: (req: GetAlertCountsRequest, endpoint: string) => Promise<AlertCountsResponse>, req: GetAlertCountsRequest): { promise: () => Promise<AlertCountsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAlertCountsEndpoint),
      endpoint: GetAlertCountsEndpoint
    };
  }

  export const GetDefinedEventCountsEndpoint = "/grpc/tally.Tally/GetDefinedEventCounts";
  export function GetDefinedEventCounts(sender: (req: GetDefinedEventCountsRequest, endpoint: string) => Promise<GetCountsResponse>, req: GetDefinedEventCountsRequest): { promise: () => Promise<GetCountsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetDefinedEventCountsEndpoint),
      endpoint: GetDefinedEventCountsEndpoint
    };
  }

  export const GetAllDefinedEventCountsEndpoint = "/grpc/tally.Tally/GetAllDefinedEventCounts";
  export function GetAllDefinedEventCounts(sender: (req: GetAllDefinedEventCountsRequest, endpoint: string) => Promise<GetAllCountsResponse>, req: GetAllDefinedEventCountsRequest): { promise: () => Promise<GetAllCountsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllDefinedEventCountsEndpoint),
      endpoint: GetAllDefinedEventCountsEndpoint
    };
  }

  export const GetApiEventCountsEndpoint = "/grpc/tally.Tally/GetApiEventCounts";
  export function GetApiEventCounts(sender: (req: GetApiEventCountsRequest, endpoint: string) => Promise<GetCountsResponse>, req: GetApiEventCountsRequest): { promise: () => Promise<GetCountsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetApiEventCountsEndpoint),
      endpoint: GetApiEventCountsEndpoint
    };
  }

  export const GetAllApiEventCountsEndpoint = "/grpc/tally.Tally/GetAllApiEventCounts";
  export function GetAllApiEventCounts(sender: (req: GetAllApiEventCountsRequest, endpoint: string) => Promise<GetAllCountsResponse>, req: GetAllApiEventCountsRequest): { promise: () => Promise<GetAllCountsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllApiEventCountsEndpoint),
      endpoint: GetAllApiEventCountsEndpoint
    };
  }

  export const GetPageCountsEndpoint = "/grpc/tally.Tally/GetPageCounts";
  export function GetPageCounts(sender: (req: GetPageCountsRequest, endpoint: string) => Promise<GetCountsIntIdResponse>, req: GetPageCountsRequest): { promise: () => Promise<GetCountsIntIdResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetPageCountsEndpoint),
      endpoint: GetPageCountsEndpoint
    };
  }

  export const GetAllPageCountsEndpoint = "/grpc/tally.Tally/GetAllPageCounts";
  export function GetAllPageCounts(sender: (req: GetAllPageCountsRequest, endpoint: string) => Promise<GetAllCountsIntIdResponse>, req: GetAllPageCountsRequest): { promise: () => Promise<GetAllCountsIntIdResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllPageCountsEndpoint),
      endpoint: GetAllPageCountsEndpoint
    };
  }

  export const GetApiEventPropertyCountsEndpoint = "/grpc/tally.Tally/GetApiEventPropertyCounts";
  export function GetApiEventPropertyCounts(sender: (req: GetPropertyCountsRequest, endpoint: string) => Promise<GetCountsResponse>, req: GetPropertyCountsRequest): { promise: () => Promise<GetCountsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetApiEventPropertyCountsEndpoint),
      endpoint: GetApiEventPropertyCountsEndpoint
    };
  }

  export const GetAllApiEventPropertyCountsEndpoint = "/grpc/tally.Tally/GetAllApiEventPropertyCounts";
  export function GetAllApiEventPropertyCounts(sender: (req: GetAllPropertyCountsRequest, endpoint: string) => Promise<GetAllCountsResponse>, req: GetAllPropertyCountsRequest): { promise: () => Promise<GetAllCountsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllApiEventPropertyCountsEndpoint),
      endpoint: GetAllApiEventPropertyCountsEndpoint
    };
  }

  export const GetElementPropertyCountsEndpoint = "/grpc/tally.Tally/GetElementPropertyCounts";
  export function GetElementPropertyCounts(sender: (req: GetPropertyCountsRequest, endpoint: string) => Promise<GetCountsResponse>, req: GetPropertyCountsRequest): { promise: () => Promise<GetCountsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetElementPropertyCountsEndpoint),
      endpoint: GetElementPropertyCountsEndpoint
    };
  }

  export const GetAllElementPropertyCountsEndpoint = "/grpc/tally.Tally/GetAllElementPropertyCounts";
  export function GetAllElementPropertyCounts(sender: (req: GetAllPropertyCountsRequest, endpoint: string) => Promise<GetAllCountsResponse>, req: GetAllPropertyCountsRequest): { promise: () => Promise<GetAllCountsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllElementPropertyCountsEndpoint),
      endpoint: GetAllElementPropertyCountsEndpoint
    };
  }

  export const GetPagePropertyCountsEndpoint = "/grpc/tally.Tally/GetPagePropertyCounts";
  export function GetPagePropertyCounts(sender: (req: GetPropertyCountsRequest, endpoint: string) => Promise<GetCountsResponse>, req: GetPropertyCountsRequest): { promise: () => Promise<GetCountsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetPagePropertyCountsEndpoint),
      endpoint: GetPagePropertyCountsEndpoint
    };
  }

  export const GetAllPagePropertyCountsEndpoint = "/grpc/tally.Tally/GetAllPagePropertyCounts";
  export function GetAllPagePropertyCounts(sender: (req: GetAllPropertyCountsRequest, endpoint: string) => Promise<GetAllCountsResponse>, req: GetAllPropertyCountsRequest): { promise: () => Promise<GetAllCountsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllPagePropertyCountsEndpoint),
      endpoint: GetAllPagePropertyCountsEndpoint
    };
  }

  export const GetUserPropertyCountsEndpoint = "/grpc/tally.Tally/GetUserPropertyCounts";
  export function GetUserPropertyCounts(sender: (req: GetPropertyCountsRequest, endpoint: string) => Promise<GetCountsResponse>, req: GetPropertyCountsRequest): { promise: () => Promise<GetCountsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetUserPropertyCountsEndpoint),
      endpoint: GetUserPropertyCountsEndpoint
    };
  }

  export const GetAllUserPropertyCountsEndpoint = "/grpc/tally.Tally/GetAllUserPropertyCounts";
  export function GetAllUserPropertyCounts(sender: (req: GetAllPropertyCountsRequest, endpoint: string) => Promise<GetAllCountsResponse>, req: GetAllPropertyCountsRequest): { promise: () => Promise<GetAllCountsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllUserPropertyCountsEndpoint),
      endpoint: GetAllUserPropertyCountsEndpoint
    };
  }
}

export interface GetProcessDefinitionHealthRequest {
  /** comma delimited list of org ids to check definition health */
  orgIds: string;
  /** solr time start time. Defaults to NOW/DAY-30DAY. */
  startTime: string;
  /** solr time end time. Defaults to NOW/DAY. */
  endTime: string;
  /** solr time now time. Defaults to NOW/DAY. */
  now: string;
  /** parallelism for processing orgs */
  nParallel: number;
  /** optional manual timeout (in seconds) for one-off requests */
  timeout: number;
}

export interface GetProcessAccuracySmokeTestRequest {
  /** solr time start time. Defaults to NOW/DAY-3DAY. */
  startTime: string;
  /** solr time end time. Defaults to NOW/DAY. */
  endTime: string;
  objectType: ObjectType;
  /** optional manual timeout (in seconds) for one-off requests */
  timeout: number;
  /** parallelism for processing orgs */
  nParallel: number;
  /** Optional orgs list to run accuracy analysis on */
  orgs: string[];
}

export interface GetElementCountsRequest {
  orgId: string;
  objectId: string;
  startTime: protobuf.timestamp | null;
  endTime: protobuf.timestamp | null;
}

export interface GetAllElementCountsRequest {
  orgId: string;
  startTimes: protobuf.timestamp[];
  endTime: protobuf.timestamp | null;
  onlyUseHourlyCounts: boolean;
}

export interface GetDefinedEventCountsRequest {
  orgId: string;
  objectId: string;
  startTime: protobuf.timestamp | null;
  endTime: protobuf.timestamp | null;
}

export interface GetAllDefinedEventCountsRequest {
  orgId: string;
  startTimes: protobuf.timestamp[];
  endTime: protobuf.timestamp | null;
  onlyUseHourlyCounts: boolean;
}

export interface GetApiEventCountsRequest {
  orgId: string;
  name?: string;
  /** optional hashed name following HashEventName hashing. If provided, will ignore the human-readable "name" field. */
  nameHash?: string;
  startTime: protobuf.timestamp | null;
  endTime: protobuf.timestamp | null;
}

export namespace GetApiEventCountsRequest {
  export enum event_id {
    name = 2,
    /** optional hashed name following HashEventName hashing. If provided, will ignore the human-readable "name" field. */
    nameHash = 3
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum event_id_keys {
    name = 'name',
    /** optional hashed name following HashEventName hashing. If provided, will ignore the human-readable "name" field. */
    nameHash = 'nameHash'
  }

  export function event_id_oneof(m: GetApiEventCountsRequest): { opt: event_id.name, key: event_id_keys.name, val: string } | { opt: event_id.nameHash, key: event_id_keys.nameHash, val: string } | null {
    if (m.name != null) { return { opt: event_id.name, key: event_id_keys.name, val: m.name } }
    if (m.nameHash != null) { return { opt: event_id.nameHash, key: event_id_keys.nameHash, val: m.nameHash } }
    return null;
  }
}

export interface GetAllApiEventCountsRequest {
  orgId: string;
  startTimes: protobuf.timestamp[];
  endTime: protobuf.timestamp | null;
  onlyUseHourlyCounts: boolean;
}

/** Returns windows of hourly counts for the specified object. [StartTime, EndTime) are inclusive and exclusive, respectively */
export interface GetCountsRequest {
  orgId: string;
  objectId: string;
  objectType: ObjectType;
  startTime: protobuf.timestamp | null;
  endTime: protobuf.timestamp | null;
  timeInterval: segment.TimeInterval;
  /** Optional timezone, will default to UTC if not provided */
  timezone: string;
}

export interface GetConvertedAlertCountsRequest {
  countsRequest: GetCountsRequest | null;
  /**
   * The size of the window, in rolling_window_interval units.  Omitting this field
   * (0-value) is the same as 1.  Values > 1 will generate a rolling window
   * for which the property will be aggregated across. Windows for each day are
   * counted backwards, so for example a 7 day window starting on October 10th,
   * will aggregate data from [October 4th, October 11th)
   * 
   * This doesn't work for "ENTIRE_RANGE" intervals (obviously).
   */
  rollingWindow: number;
  /** Rolling window type specifies what kind of rolling window computation is being performed. */
  rollingWindowType: metrics.Measure.RollingWindowType;
  /** If computing a windowed metric, then this the size of each window */
  rollingWindowInterval: segment.TimeInterval;
}

/** Returns windows of total results for objects grouped by the startTime(s) passed in. */
export interface GetAllCountsRequest {
  orgId: string;
  objectType: ObjectType;
  startTimes: protobuf.timestamp[];
  endTime: protobuf.timestamp | null;
  /**
   * NB: Only to be used for testing.
   * Do not use daily totals for the counts. Results should be the same, except at tail ends
   */
  onlyUseHourlyCounts: boolean;
}

export interface GetAlertCountsRequest {
  orgId: string;
  /** Defines the computation. */
  computation: metrics.Computation | null;
  /** The time window for which to retrieve counts */
  timeRange: segment.TimeRange | null;
  /**
   * The interval used to determine buckets of DataTable.
   * Data will only be added to a bucket if it also falls within the time_range above.
   */
  timeInterval: segment.TimeInterval;
  /** Optional now time, will default to current time.Now if not provided */
  now: protobuf.timestamp | null;
  /** Optional timezone, will default to UTC if not provided */
  timezone: string;
}

export interface GetPageCountsRequest {
  orgId: string;
  objectId: number;
  startTime: protobuf.timestamp | null;
  endTime: protobuf.timestamp | null;
}

export interface GetAllPageCountsRequest {
  orgId: string;
  startTimes: protobuf.timestamp[];
  endTime: protobuf.timestamp | null;
  onlyUseHourlyCounts: boolean;
}

export interface GetPropertyCountsRequest {
  orgId: string;
  id?: vars.UnscopedVarId | null;
  /** optional hashed property id following HashProperty hashing. If provided, will ignore the human-readable "id" field. */
  idHash?: string;
  startTime: protobuf.timestamp | null;
  endTime: protobuf.timestamp | null;
}

export namespace GetPropertyCountsRequest {
  export enum property_id {
    id = 2,
    /** optional hashed property id following HashProperty hashing. If provided, will ignore the human-readable "id" field. */
    idHash = 3
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum property_id_keys {
    id = 'id',
    /** optional hashed property id following HashProperty hashing. If provided, will ignore the human-readable "id" field. */
    idHash = 'idHash'
  }

  export function property_id_oneof(m: GetPropertyCountsRequest): { opt: property_id.id, key: property_id_keys.id, val: vars.UnscopedVarId } | { opt: property_id.idHash, key: property_id_keys.idHash, val: string } | null {
    if (m.id != null) { return { opt: property_id.id, key: property_id_keys.id, val: m.id } }
    if (m.idHash != null) { return { opt: property_id.idHash, key: property_id_keys.idHash, val: m.idHash } }
    return null;
  }
}

export interface GetAllPropertyCountsRequest {
  orgId: string;
  startTimes: protobuf.timestamp[];
  endTime: protobuf.timestamp | null;
  onlyUseHourlyCounts: boolean;
}

export interface GetCountsResponse {
  results: WindowedCount[];
  objectMetadata: ObjectMetadata | null;
}

export interface GetCountsIntIdResponse {
  results: WindowedCountIntId[];
  objectMetadata: ObjectMetadata | null;
}

export interface GetAllCountsResponse {
  results: WindowedCount[];
}

export interface GetAllCountsIntIdResponse {
  results: WindowedCountIntId[];
}

export interface ObjectTokens {
  insertions: { [key: string]: OrgInteraction };
  deletions: { [key: string]: OrgInteraction };
}

export interface OrgInteraction {
  orgId: string;
  objectId: string;
  objectType: ObjectType;
  startTime: protobuf.timestamp | null;
}

export interface WindowedOrgCountsInput {
  orgId: string;
  counts: WindowedCount[];
  windowId: string;
  forBackfill: boolean;
}

export interface WindowedCount {
  objectId: string;
  objectType: ObjectType;
  count: protobuf.int64;
  startTime: protobuf.timestamp | null;
}

export interface WindowedCountIntId {
  objectId: number;
  objectType: ObjectType;
  count: protobuf.int64;
  startTime: protobuf.timestamp | null;
}

export enum ObjectType {
  INVALID = 0,
  ELEMENT = 1,
  ALERT_EVENT = 2,
  DEFINED_EVENT = 3,
  API_EVENT = 4,
  PAGE = 5,
  API_EVENT_PROPERTY = 6,
  ELEMENT_PROPERTY = 7,
  PAGE_PROPERTY = 8,
  USER_PROPERTY = 9
}

export interface ObjectMetadata {
  firstSeen: protobuf.timestamp | null;
  lastSeen: protobuf.timestamp | null;
}

export interface AlertCountsResponse {
  /** Data table for the computed results. */
  data: metrics.DataTable | null;
}

export interface DefinitionHealthEvent {
  nonZeroElements: protobuf.int64;
  activeZeroElements: protobuf.int64;
  inactivePercentElements: number;
  snoozedZeroElements: protobuf.int64;
  archivedElements: protobuf.int64;
  totalElements: protobuf.int64;
  plan: string;
  lookbackDays: number;
  orgId: string;
  startTime: protobuf.timestamp | null;
  endTime: protobuf.timestamp | null;
  /** element created after start of run */
  createdAfterElements: protobuf.int64;
  nonZeroDefinedEvents: protobuf.int64;
  activeZeroDefinedEvents: protobuf.int64;
  inactivePercentDefinedEvents: number;
  snoozedZeroDefinedEvents: protobuf.int64;
  archivedDefinedEvents: protobuf.int64;
  totalDefinedEvents: protobuf.int64;
  createdAfterDefinedEvents: protobuf.int64;
  nonZeroApiEvents: protobuf.int64;
  activeZeroApiEvents: protobuf.int64;
  inactivePercentApiEvents: number;
  snoozedZeroApiEvents: protobuf.int64;
  archivedApiEvents: protobuf.int64;
  totalApiEvents: protobuf.int64;
}
